module.exports = __webpack_public_path__ + "static/img/kaback.c3fc88b0.png";